<template>
  <div id="box" class="chat-box">
    <div class="vender-machine not-copy">
      <div class="header-message">
        <p class="main-message">現在まで{{alreadyCount}}{{lastMessage}}</p>
        <p>{{secondMessage}}</p>
      </div>
      <div class="dot-line"></div>
        <div class="control has-addons">
          <input class="input is-small bot-input" type="search" name="search" placeholder="🔍ロボ検索" v-model="keyword" @keyup.enter="search">
        </div>
          <div v-if="tabAll && !showSearch">
            <div class="bot-box">
              <div class="next-arrow" @click="nextView(true)" v-if="widgetData.isAuto && all.length > getSizeBot()">＞</div>
              <div class="icon-box list-icon" :class="'list-icon-' + Number(k + 1)" v-for="(b, k) in all" :key="k" v-if="widgetData.isAuto && all.length > 0 && k < (pageIndexBots + getSizeBot()) && k >= pageIndexBots">
                <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
                <!-- <img class="star-tag" ssrc="@/assets/template/kunsyo.svg" v-if="widgetData.recommendBot == b.bot_id"/> -->
                <div class="workday-tooltip">
                  <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                  <div class="bg-filter-box" @click="openChatBot(b, widgetData.todayIsHoliday)">
                    <img class="img-icon" :style="makeImgIcon()" @error="imageError(b.bot_id)" :src="b.icon_data" v-if="b.icon_data && loadImageError(b.bot_id)">
                    <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                  </div>
                  <p class="name">{{b.display_name}}</p>
                  <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
                </div>
              </div>
              <div class="icon-box list-icon" :class="'list-icon-' + Number(6)" v-if="!isPaging && color.staffbotType == 0">
                <div class="bg-filter-box" @click="openDirectTalk(widgetData.users[0])">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/team.png"/>
                </div>
                <p class="name">スタッフと直接会話する</p>
                <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
              </div>
            </div>
          </div>
          <div v-if="tab0 && !showSearch">
            <div class="bot-box">
              <div class="next-arrow" @click="nextView(true)" v-if="widgetData.isAuto && procedure.length > getSizeBot()">＞</div>
              <div class="icon-box list-icon" :class="'list-icon-' + Number(k + 1)" v-for="(b, k) in procedure" :key="k" v-if="widgetData.isAuto && procedure.length > 0 && k < (pageIndexBots + getSizeBot()) && k >= pageIndexBots">
                <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
                <img class="star-tag" src="@/assets/template/kunsyo.svg" v-if="widgetData.recommendBot == b.bot_id"/>
                <div class="workday-tooltip">
                  <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                  <div class="bg-filter-box" @click="openChatBot(b, widgetData.todayIsHoliday)">
                    <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                    <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                  </div>
                  <p class="name">{{b.display_name}}</p>
                  <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
                </div>
              </div>
              <div class="icon-box list-icon" :class="'list-icon-' + Number(6)" v-if="!isPaging">
                <div class="bg-filter-box" @click="openDirectTalk(widgetData.users[0])">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/team.png"/>
                </div>
                <p class="name">スタッフと直接会話する</p>
                <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
              </div>
            </div>
          </div>
        <div v-if="tab1 && !showSearch">
          <div class="bot-box">
            <div class="next-arrow" @click="nextView(true)" v-if="widgetData.isAuto && consultation.length > getSizeBot()">＞</div>
            <div class="icon-box list-icon" :class="'list-icon-' + Number(k + 1)" v-for="(b, k) in consultation" :key="k" v-if="widgetData.isAuto && consultation.length > 0 && k < (pageIndexBots + getSizeBot()) && k >= pageIndexBots">
              <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
              <img class="star-tag" src="@/assets/template/kunsyo.svg" v-if="widgetData.recommendBot == b.bot_id"/>
              <div class="workday-tooltip">
                <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                <div class="bg-filter-box" @click="openChatBot(b, widgetData.todayIsHoliday)">
                  <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                </div>
                <p class="name">{{b.display_name}}</p>
                <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
              </div>
            </div>
            <div class="icon-box list-icon" :class="'list-icon-' + Number(6)" v-if="!isPaging">
              <div class="bg-filter-box" @click="openDirectTalk(widgetData.users[0])">
                <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/team.png"/>
              </div>
              <p class="name">スタッフと直接会話する</p>
              <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
            </div>
          </div>
        </div>
        <div v-if="tab2 && !showSearch">
          <div class="bot-box">
            <div class="next-arrow" @click="nextView(true)" v-if="widgetData.isAuto && info.length > getSizeBot()">＞</div>
            <div class="icon-box list-icon" :class="'list-icon-' + Number(k + 1)" v-for="(b, k) in info" :key="k" v-if="widgetData.isAuto && info.length > 0 && k < (pageIndexBots + getSizeBot()) && k >= pageIndexBots">
              <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
              <img class="star-tag" src="@/assets/template/kunsyo.svg" v-if="widgetData.recommendBot == b.bot_id"/>
              <div class="workday-tooltip">
                <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                <div class="bg-filter-box" @click="openChatBot(b, widgetData.todayIsHoliday)">
                  <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                </div>
                <p class="name">{{b.display_name}}</p>
                <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
              </div>
            </div>
            <div class="icon-box list-icon" :class="'list-icon-' + Number(6)" v-if="!isPaging">
              <div class="bg-filter-box" @click="openDirectTalk(widgetData.users[0])">
                <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/team.png"/>
              </div>
              <p class="name">スタッフと直接会話する</p>
              <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
            </div>
          </div>
        </div>
        <div v-if="tab3 && !showSearch">
          <div class="bot-box">
            <div class="next-arrow" @click="nextView(true)" v-if="widgetData.isAuto && news.length > getSizeBot()">＞</div>
            <div class="icon-box list-icon" :class="'list-icon-' + Number(k + 1)" v-for="(b, k) in news" :key="k" v-if="widgetData.isAuto && news.length > 0 && k < (pageIndexBots + getSizeBot()) && k >= pageIndexBots">
              <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
              <img class="star-tag" src="@/assets/template/kunsyo.svg" v-if="widgetData.recommendBot == b.bot_id"/>
              <div class="workday-tooltip">
                <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                <div class="bg-filter-box" @click="openChatBot(b, widgetData.todayIsHoliday)">
                  <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                </div>
                <p class="name">{{b.display_name}}</p>
                <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
              </div>
            </div>
            <div class="icon-box list-icon" :class="'list-icon-' + Number(6)" v-if="!isPaging">
              <div class="bg-filter-box" @click="openDirectTalk(widgetData.users[0])">
                <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/team.png"/>
              </div>
              <p class="name">スタッフと直接会話する</p>
              <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
            </div>
          </div>
        </div>
        <div v-if="showSearch">
          <div class="bot-box">
            <div class="next-arrow" @click="nextView(true)" v-if="widgetData.isAuto && searchHit.length > getSizeBot()">＞</div>
            <div class="icon-box list-icon" :class="'list-icon-' + Number(k + 1)" v-for="(b, k) in searchHit" :key="k" v-if="widgetData.isAuto && searchHit.length > 0 && k < (pageIndexBots + getSizeBot()) && k >= pageIndexBots">
              <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
              <img class="star-tag" src="@/assets/template/kunsyo.svg" v-if="widgetData.recommendBot == b.bot_id"/>
              <div class="workday-tooltip">
                <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                <div class="bg-filter-box" @click="openChatBot(b, widgetData.todayIsHoliday)">
                  <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                </div>
                <p class="name">{{b.display_name}}</p>
                <div class="bln-box" v-if="rFlg === k">{{ramdomMessage()}}</div>
              </div>
            </div>
            <div class="not-found-msg" v-if="this.notFound !== ''">{{this.notFound}}</div>
          </div>
        </div>
      <!-- <div class="vending-header">
        <p>スタッフチャット</p>
      </div>
      <div class="human-box">
        <div class="next-arrow-human" @click="nextView(false)" v-if="widgetData.users.length > getSizeHuman()">＞</div>
        <div class="icon-human-box list-icon" :class="'list-icon-' + Number(widgetData.bots.length + k + 1)" v-for="(u, k) in widgetData.users" :key="`A-${k}`" v-if="k < (pageIndexUsers + getSizeHuman()) && k >= pageIndexUsers && !u.isAgent">
          <div class="bg-filter-box" @click="openDirectTalk(u)">
            <img class="img-icon" :src="u.icon" v-if="u.isConnect==='1'||true">
          </div>
          <p class="name">{{u.username}}</p>
        </div>
      </div> -->
    </div>
    <!-- ロボタグ修正に伴いコメントアウト -->
    <!-- <ul class="tabs" v-if="color.categorymenuType == 0">
      <li class="tabs_item" @click="tabAllClick">
        <p class="tabs_icon"><i class="mdi mdi-apps"></i></p>
        <p class="tabs_name" style="margin-bottom:1em;">一覧</p>
      </li>
      <li class="tabs_item" @click="tab0Click">
        <p class="tabs_icon"><i class="mdi mdi-newspaper"></i></p>
        <p class="tabs_name">ニュース・<br>トピック</p>
      </li>
      <li class="tabs_item" @click="tab1Click">
        <p class="tabs_icon"><i class="mdi mdi-comment-processing-outline"></i></p>
        <p class="tabs_name">相談<br>（匿名可）</p>
      </li>
      <li class="tabs_item" @click="tab2Click">
        <p class="tabs_icon"><i class="mdi mdi-pencil-box-outline"></i></p>
        <p class="tabs_name">手続き</p>
      </li>
    </ul> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import resetLocalStorageSeeker from '@/functions/resetLocalStorageSeeker'
import {
  isOffDuty,
  getWorkDayMessage,
  getWorkTimeMessage,
} from '@/functions/robo/roboOffDuty'

export default {
  name: 'SelectConvVender',
  data () {
    return {
      activeTab: 0,
      url: process.env.WDT_ENDPOINT,
      pos: null,
      cardWidth: 0,
      currentWidth: null,
      kMobile: 33,
      kPC: 3.72,
      kx: 2,
      mobileWidth: 320,
      number: 0,
      cardIdx: 0,
      count: 0,
      iNum: 0,
      animInFlg: [],
      animOutFlg: [],
      animInPrevFlg: [],
      animOutPrevFlg: [],
      bot: null,
      botIndex: -1,
      pageIndexBots: 0,
      pageIndexUsers: 0,
      isPaging: false,
      pageFlg: false,
      rFlg: 0,
      rMsg: 0,
      lastMessage: '名の\n訪問者と会話しております。',
      secondMessage: '会社情報の閲覧や\nメッセージのやりとりができます。',
      procedure: [],
      consultation: [],
      info: [],
      news: [],
      all: [],
      keyword: '',
      searchHit: [],
      showSearch: false,
      notFound: '',
      tabAll: true,
      tab0: false,
      tab1: false,
      tab2: false,
      tab3: false,
      intervalId: undefined,
      staffBotFlg: false,
      pageIndexStaffbot: 0,
      isImageError: []
    }
  },
  computed: {
    ...mapState('directtalk', ['widgetData', 'color', 'data', 'targetID', 'selectTagNewMsg', 'alreadyCount', 'seeker']),
    ...mapState('chatbot', ['minipk']),
  },
  mounted () {
    console.debug('*** Start *** mounted')
    this.intervalId = setInterval(() => {
      this.rFlg = this.getRandomInt(this.widgetData.bots.length)
      this.rMsg = this.getRandomInt(6)
    }, 2500)
    this.isCategories()
    // this.enterKey()
    console.debug('*** End *** mounted')
    this.isStaffBot()
  },
  beforeDestroy () {
    console.debug('*** Start *** beforeDestroy')
    clearInterval(this.intervalId)
    console.debug('*** End *** beforeDestroy')
  },
  methods: {
    isStaffBot () {
      if (this.color.staffbotType == 1) {
        this.staffBotFlg == false
        this.pageIndexStaffbot = 1
      } else {
        this.staffBotFlg == true
      }
    },
    isCategories () {
      for ( var v of this.widgetData.bots){
        var category = v.parameter.category.map ( (e) => {
          if (e.idx == 0) {
            this.procedure.push(v)
          } else if (e.idx == 1) {
            this.consultation.push(v)
          } else if (e.idx == 2) {
            this.info.push(v)
          } else if (e.idx == 3) {
            this.news.push(v)
          }
          this.all.push(v)
        })
      }
      this.all = [...new Set(this.all)]
    },
    getRandomInt (max) {
      return Math.floor(Math.random() * Math.floor(max))
    },
    ramdomMessage () {
      switch (this.rMsg) {
        case 0:
          return 'こちらから会話できます！'
          break
        case 1:
          return 'こんにちは！'
          break
        case 2:
          return 'ようこそ！'
          break
        case 3:
          return 'お気軽にどうぞ！'
          break
        case 4:
          return 'ロボです！'
          break
        case 5:
          return 'お話ししませんか？'
          break
      }
    },
    nextView (isBot) {
      var w = document.body.clientWidth

      this.isPaging = true
      this.pageFlg = !this.pageFlg
      if (isBot && w > 500) {
        if (this.widgetData.bots.length <= (this.pageIndexBots + 5 + this.pageIndexStaffbot)) this.pageIndexBots = 0
        else this.pageIndexBots += 5 + this.pageIndexStaffbot
      // } else if (!isBot && w > 500) {
      //   if (this.widgetData.users.length <= (this.pageIndexUsers + 2)) this.pageIndexUsers = 0
      //   else this.pageIndexUsers += 2
      } else if (isBot && w <= 500) {
        if (this.widgetData.bots.length <= (this.pageIndexBots + 5 + this.pageIndexStaffbot)) this.pageIndexBots = 0
        else this.pageIndexBots += 5 + this.pageIndexStaffbot
      // } else if (!isBot && w <= 500) {
      //   if (this.widgetData.users.length <= (this.pageIndexUsers + 3)) this.pageIndexUsers = 0
      //   else this.pageIndexUsers += 3
      }
      setTimeout(() => {this.isPaging = false}, 100)
      console.debug('*** End *** nextView')
    },
    onChange() {
      console.debug('*** Start *** onChange')
      if (this.pageFlg === true) {
        this.fixPage(true)
      }
      console.debug('*** End *** onChange')
    },
    fixPage (isBot) {
      console.debug('*** Start *** fixPage')
      console.debug('isBot: ' + JSON.stringify(isBot))
      var w = document.body.clientWidth
      this.isPaging = true
      this.pageFlg = !this.pageFlg
      if (isBot && w > 500) {
        if (this.widgetData.bots.length <= (this.pageIndexBots + 5)) this.pageIndexBots = 0
        else this.pageIndexBots += 5
      } else if (!isBot && w > 500) {
        if (this.widgetData.users.length <= (this.pageIndexUsers + 2)) this.pageIndexUsers = 0
        else this.pageIndexUsers += 2
      } else if (isBot && w <= 500) {
        if (this.widgetData.bots.length <= (this.pageIndexBots + 5)) this.pageIndexBots = 0
        else this.pageIndexBots += 5
      } else if (!isBot && w <= 500) {
        if (this.widgetData.users.length <= (this.pageIndexUsers + 3)) this.pageIndexUsers = 0
        else this.pageIndexUsers += 3
      }
      this.isPaging = false
      console.debug('*** End *** fixPage')
    },
    getSizeBot () {
      console.debug('*** Start *** getSizeBot')
      var w = screen.width
      if (w > 500) return 5 + this.pageIndexStaffbot
      else  return 5 + this.pageIndexStaffbot
    },
    getSizeHuman () {
      console.debug('*** Start *** getSizeHuman')
      var w = screen.width
      if (w > 500) return 2
      else return 3
    },
    isStartBot (b) {
      console.debug('*** Start *** isStartBot')
      console.debug('b: ' + JSON.stringify(b))
      var urlAryS = b.start_url.split('|')
      for (var j in urlAryS) {
        if (urlAryS[j] == this.data.url) return true
      }
      return false
    },
    hoverClass (event, idx, flg) {
      console.debug('*** Start *** hoverClass')
      console.debug('event: ' + JSON.stringify(event))
      console.debug('idx: ' + JSON.stringify(idx))
      console.debug('flg: ' + JSON.stringify(flg))
      var ch = document.querySelector('a.hover-chat-' + idx)
      var sk = document.querySelector('a.hover-skill-' + idx)
      if (!flg) {
        ch.style.opacity = 0
        sk.style.opacity = 0
        ch.style.transform = 'scale(0, 1)'
        sk.style.transform = 'scale(0, 1)'
      } else {
        ch.style.opacity = 1
        sk.style.opacity = 1
        ch.style.transform = 'scale(1, 1)'
        sk.style.transform = 'scale(1, 1)'
      }
      console.log('idx: ' + idx + ', flg: ' + flg)
      console.debug('*** End *** hoverClass')
    },
    makeImgIcon () {
      console.debug('*** Start *** makeImgIcon')
      return {
        'border-color': this.color.iconBg
      }
    },
    makeColor () {
      console.debug('*** Start *** makeColor')
      return {
        'background': this.color.iconBg,
        'color': this.color.iconFr,
        'border-color': this.color.iconBg
      }
    },
    makeColorR () {
      console.debug('*** Start *** makeColorR')
      return {
        'background': this.color.iconFr,
        'color': this.color.iconBg,
        'border-color': this.color.iconBg
      }
    },
    hoverColor (event) {
      console.debug('*** Start *** hoverColor')
      console.debug('event: ' + JSON.stringify(event))
      if (this.data.width > 500) {
        event.target.style.background = this.color.iconFr
        event.target.style.color = this.color.iconBg
        event.target.style.borderColor = this.color.iconBg
        event.preventDefault()
      }
      console.debug('*** End *** hoverColor')
    },
    leaveColor (event) {
      console.debug('*** Start *** leaveColor')
      console.debug('event: ' + JSON.stringify(event))
      if (this.data.width > 500) {
        event.target.style.background = this.color.iconBg
        event.target.style.color = this.color.iconFr
        event.target.style.borderColor = this.color.iconBg
        event.preventDefault()
      }
      console.debug('*** End *** leaveColor')
    },
    hoverColorDel (event) {
      console.debug('*** Start *** hoverColorDel')
      console.debug('event: ' + JSON.stringify(event))
      event.target.style.background = ''
      event.target.style.color = ''
      event.target.style.borderColor = ''
      event.preventDefault()
      console.debug('*** End *** hoverColorDel')
    },
    leaveColorDel (event) {
      console.debug('*** Start *** leaveColorDel')
      console.debug('event: ' + JSON.stringify(event))
      event.target.style.background = ''
      event.target.style.color = ''
      event.target.style.borderColor = ''
      event.preventDefault()
      console.debug('*** End *** leaveColorDel')
    },
    getLocate (idx, isBot) {
      console.debug('*** Start *** getLocate')
      console.debug('idx: ' + JSON.stringify(idx))
      console.debug('isBot: ' + JSON.stringify(isBot))
      var translate = ''
      var scale = ''
      if (isBot) {
        translate = (this.widgetData.bots.length + this.widgetData.users.length) * this.kx - idx * this.kx
        translate += (this.widgetData.bots.length + this.widgetData.users.length) * this.kx / (this.widgetData.bots.length + this.widgetData.users.length)
        console.debug('*** End *** getLocate')
        return {
          // 'transform': 'rotate(' + deg + 'deg)' + translate,
          // 'transform': 'translate(' + translate + 'px, ' + translate  + 'px)' + scale,
          'z-index'  : (this.widgetData.bots.length + this.widgetData.users.length) * this.kx - idx
        }
      } else {
        translate = (this.widgetData.users.length) * this.kx - idx * this.kx
        translate += (this.widgetData.bots.length + this.widgetData.users.length) * this.kx / (this.widgetData.bots.length + this.widgetData.users.length)
        console.debug('*** End *** getLocate')
        return {
          // 'transform': 'rotate(' + deg + 'deg)' + translate,
          // 'transform': 'translate(' + translate + 'px, ' + translate  + 'px)' + scale,
          'z-index'  : (this.widgetData.users.length) * this.kx - idx
        }
      }
    },
    nextCard () {
      console.debug('*** Start *** nextCard')
      var max = this.widgetData.bots.length + this.widgetData.users.length - 1
      for (var i = 0; i < max + 1; i++) {
        this.animInPrevFlg[i] = false
        this.animInPrevFlg.splice()
        this.animOutPrevFlg[i] = false
        this.animOutPrevFlg.splice()
      }
      this.animInFlg[this.cardIdx] = true
      this.animInFlg.splice()
      for (var i = 0; i < max + 1; i++) if (this.cardIdx !== i) this.animInFlg[i] = false
      this.animInFlg.splice()
      if (this.cardIdx < max) this.cardIdx += 1
      else this.cardIdx = 0
      this.animOutFlg[this.cardIdx] = true
      var card = document.getElementById('slide-' + this.cardIdx)
      card.style.zIndex = '' + (9999 + this.count)
      for (var i = 0; i < max + 1; i++) if (this.cardIdx !== i) this.animOutFlg[i] = false
      this.animOutFlg.splice()
      this.count++
      console.debug('*** End *** nextCard')
    },
    prevCard () {
      console.debug('*** Start *** nextCard')
      var max = this.widgetData.bots.length + this.widgetData.users.length - 1
      for (var i = 0; i < max + 1; i++) {
        this.animInFlg[i] = false
        this.animInFlg.splice()
        this.animOutFlg[i] = false
        this.animOutFlg.splice()
      }
      this.animInPrevFlg[this.cardIdx] = true
      this.animInPrevFlg.splice()
      for (var i = 0; i < max + 1; i++) if (this.cardIdx !== i) this.animInPrevFlg[i] = false
      this.animInPrevFlg.splice()
      if (this.cardIdx > 0) this.cardIdx -= 1
      else this.cardIdx = this.widgetData.bots.length + this.widgetData.users.length - 1
      this.animOutPrevFlg[this.cardIdx] = true
      var card = document.getElementById('slide-' + this.cardIdx)
      card.style.zIndex = '' + (9999 + this.count)
      for (var i = 0; i < max + 1; i++) if (this.cardIdx !== i) this.animOutPrevFlg[i] = false
      this.animOutPrevFlg.splice()
      this.count++
      console.debug('*** End *** nextCard')
    },
    mainSubstring (n) {
      console.debug('*** Start *** mainSubstring')
      console.debug('n: ' + JSON.stringify(n))
      return n.length < 21 ? n : n.substring(0, 19) + '...'
    },
    likeCount (uid, name, type) {
      console.debug('*** Start *** likeCount')
      console.debug('uid: ' + JSON.stringify(uid))
      console.debug('name: ' + JSON.stringify(name))
      console.debug('type: ' + JSON.stringify(type))
      this.$store.dispatch('directtalk/addCount', {'uid': uid, 'name': name, 'type': type})
      this.$forceUpdate()
      console.debug('*** End *** likeCount')
    },
    nameString (n) {
      if (n !== null && n !== '' && n !== 'None') return n.length < 10 ? n : n.substring(0, 8) + '...'
    },
    openDirectTalk (u) {
      this.$store.dispatch('directtalk/setDT', {name: u.username, icon: u.icon, id: u.userID, model: 'user'})
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: 'none', action: 'click_room', url: this.data.url, element: 'button'})
      this.$emit('changeModalDialog')
    },
    openChatBot (b, todayIsHoliday) {
      if (isOffDuty(b, todayIsHoliday)) {
        // 勤務時間外
        return
      }
      let targetMini = this.minipk || null
      let selectMini = b.pk || null
      if (this.targetID !== b.bot_id || targetMini !== selectMini) {
        this.$emit('openCB', b.header_title, b.bot_header_type)
        this.$store.dispatch('directtalk/setDT', {name: b.display_name, icon: b.icon_data, id: b.bot_id, model: 'bot'})
        this.$store.dispatch('chatbot/setMiniPK', selectMini)
        this.$store.dispatch('directtalk/createSeekerATHistory', {target: b.display_name, action: 'click_room', url: this.data.url, element: 'button'})
        this.createSKTagHistory('click_room', b.tag)
        let id = b.pk || b.bot_id
        let lv = localStorage.getItem('scenariolv_' + id)
        if (lv) {
          lv = JSON.parse(lv)
          lv.scenario_name = b.scenario_name
          if (lv.node == '') {
            lv = null
            localStorage.removeItem('scenariolv_' + id)
          }
        }
        if (!lv) {
          resetLocalStorageSeeker(this.seeker.id)
          this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: b.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: b.pk ? b.pk : null})
        }
        this.$store.commit('chatbot/SET_LAST_VIEW', lv)
      } else {
        this.$store.dispatch('directtalk/setDT', {name: b.display_name, icon: b.icon_data, id: b.bot_id, model: 'bot'})
        this.$store.dispatch('chatbot/setMiniPK', selectMini)
        this.$store.dispatch('directtalk/createSeekerATHistory', {target: b.display_name, action: 'click_room', url: this.data.url, element: 'button'})
        this.createSKTagHistory('click_room', b.tag)
      }
      this.$emit('changeModalDialog')
    },
    isOffDuty (robo, todayIsHoliday) {
      // ロボ非番判定
      return isOffDuty(robo, todayIsHoliday)
    },
    getWorkDayMessage (robo) {
      // 稼働日メッセージ取得
      return getWorkDayMessage(robo)
    },
    getWorkTimeMessage (robo) {
      // 稼働時間メッセージ取得
      return getWorkTimeMessage(robo)
    },
    search () {
      console.debug('*** Start *** search')
      this.notFound = ''
      if (this.keyword !== '') {
        this.searchHit = []
        for (var bots of this.widgetData.bots) {
          if (bots.display_name.indexOf(this.keyword) > -1) {
            this.searchHit.push(bots)
          }
        }
        if (this.searchHit.length === 0) {
          this.notFound = 'マッチするロボが見つかりませんでした。'
        }
        this.showSearch = true
        this.activeTab = 4
        this.$emit('tab-name', '検索結果')
      } 
      console.debug('*** End *** search')
    },
    tabAllClick () {
      console.debug('*** Start *** tabAllClick')
      this.tab0 = false
      this.tab1 = false
      this.tab2 = false
      this.tab3 = false
      this.showSearch = false
      this.tabAll = true
      this.$emit('tab-name', 'ロボ一覧')
      this.onChange()
      console.debug('*** End *** tabAllClick')
    },
    tab0Click () {
      console.debug('*** Start *** tab0Click')
      this.tabAll = false
      this.tab1 = false
      this.tab2 = false
      this.tab3 = false
      this.showSearch = false
      this.tab0 = true
      this.$emit('tab-name', 'ニュース・トピック')
      this.onChange()
      console.debug('*** End *** tab0Click')
    },
    tab1Click () {
      console.debug('*** Start *** tab1Click')
      this.tabAll = false
      this.tab0 = false
      this.tab2 = false
      this.tab3 = false
      this.showSearch = false
      this.tab1 = true
      this.$emit('tab-name', '相談（匿名可）')
      this.onChange()
      console.debug('*** End *** tab1Click')
    },
    tab2Click () {
      console.debug('*** Start *** tab2Click')
      this.tabAll = false
      this.tab0 = false
      this.tab1 = false
      this.tab3 = false
      this.showSearch = false
      this.tab2 = true
      this.$emit('tab-name', '手続き')
      this.onChange()
      console.debug('*** End *** tab2Click')
    },
    tab3Click () {
      console.debug('*** Start *** tab3Click')
      this.tabAll = false
      this.tab0 = false
      this.tab1 = false
      this.tab2 = false
      this.showSearch = false
      this.tab3 = true
      this.$emit('tab-name', '情報案内')
      this.onChange()
      console.debug('*** End *** tab3Click')
    },
    createSKTagHistory (action_name, tag) {
      const tempSeekerTagHistory = {
        seeker: this.seeker.pk,
        action_name: 'click_room',
        url: this.data.url,
        tag: tag
      }
      this.$store.dispatch('directtalk/createSeekerTagHistory', tempSeekerTagHistory)
    },
    imageError (id) {
      this.isImageError.push(id)      
    },
    loadImageError(id) {
      if　(this.isImageError.indexOf(id) == -1){
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.chat-box {
  position: relative !important;
  height: 100%;
  width:  100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.vender-machine {
  width: 100%;
  height: calc(100% - 100px);
  padding: 10px;
  padding-top: 8px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.vender-machine::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.main-message {
  margin-top: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #AE2B98;
}
.dot-line {
  margin-top:    8px;
  margin-bottom: 32px;
  width: 80%;
  height: 5px;
  background-size: 5px;
  background-image: url(../../../assets/template/dot.png);
}
.vending-header {
  padding: 0 8px 8px 8px;
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bot-box {
  width: 560px;
  height: 350px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-top: 16px;
  position: relative;
  margin: auto;
  margin-top: 16px;
}
.next-arrow {
  position: absolute;
  cursor: pointer;
  top: 40%;
  right: -30px;
  width: 30px;
  height: 50px;
  border: solid 2px #777;
  border-radius: 5px;
  color: #777;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.next-arrow-human {
  position: absolute;
  cursor: pointer;
  top: 40%;
  right: 235px;
  width: 30px;
  height: 50px;
  border: solid 2px #777;
  border-radius: 5px;
  color: #777;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.human-box {
  height: 30%;
  width: 90%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-top: 15px;
  position: relative;
}
.tag-num {
  display: none;
  position: absolute;
  font-size: 16.5px;
  right: -5px;
  top: -5px;
  background: #ff3355;
  color: white;
  width:  32px;
  height: 32px;
  border-radius: 50%;
  z-index: 100;
  animation: huwahuwa 2.35s ease infinite;
}
.star-tag {
  position: absolute;
  left: -10px;
  bottom: 33px;
  color: white;
  width:  48px;
  height: 48px;
  border-radius: 50%;
  z-index: 100;
  animation: huwahuwa 2.35s ease infinite;
}
.bln-box {
  width: 200px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -72px;
  background: #444;
  color: white;
  border-radius: 25px;
  font-size: 13.5px;
  padding: 5px;
}
.bln-box::before {
  content: '';
  position: absolute;
  bottom: -20px;
  left: 30%;
  margin-left: -14px;
  border: 14px solid transparent;
  border-top-color: #444;
  transform: rotateZ(-15deg);
}
.footer-box {
  height: 30px;
  width: 100%;
}
.icon-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin: 5px;
  margin-left:  7.5%;
  margin-right: 7.5%;
  -webkit-overflow-scrolling: touch;
}
.icon-box:hover {
  transform: scale(1.05);
}
.icon-human-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin: 5px;
}
.icon-human-box:hover {
  transform: scale(1.05);
}
.img-icon {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: solid 3px;
}
.bg-filter-box {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 100px;
  width:  100px;
  border-radius: 15px;
  animation: huwahuwa 2.35s ease infinite;
}
.not-found-msg{
  margin: auto;
  font-weight: bold;
  font-size: 18px;
}
.has-addons{
  display: flex;
}
.bot-input{
  width: 480px;
}
.tabs {
  font-size: bold;
  padding: 4px 0;
  width: 100%;
  background: #333;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
.tabs_item {
  width: 33%;
  color: white;
  font-weight: bold;
  background: #333;
  border: none;
  font-size: 14px;
  cursor: pointer;
}
.tabs_icon {
  font-size: 22px;
}
.tabs_name {
  font-size: 10px;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-7.5px);
  }
  100% {
    transform: translateY(0px);
  }
}
.name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 40px;
  width:  100px;
  font-size: 12.5px;
  padding-top: 5px;
  margin-top:10px;
  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  color: #555;
}
@for $i from 0 through 100 {
  &.hover-chat-#{$i} {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: white;
    cursor: pointer;
    background: rgba(200, 100, 100, 0.9);
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  &.hover-skill-#{$i} {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: white;
    cursor: pointer;
    background: rgba(100, 100, 200, 0.9);
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
@keyframes slide-in {
  0% {
    opacity: 0;
    transform: scale(0) translateX(300px);
  }
  70% {
    opacity: 0;
    transform: scale(0) translateX(300px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateX(0);
  }
}
/* Mobile Screen */
@media screen and (max-width: 500px) {
  .vender-machine {
    padding-top: 10px;
    align-items: center;
    justify-content: flex-start;
    overflow-y: scroll;
  }
  .header-message > p {
    font-size: 16px;
    white-space: pre-wrap;
    margin: 5px;
  }
  .vending-header {
    font-size: 13px;
    height: 6%;
  }
  .icon-box {
    position: relative;
    justify-content: space-evenly;
    width:  80px;
    height: 115px;
    margin: 2px;
    margin-left:  4%;
    margin-right: 3%;
  }
  .next-arrow {
    position: absolute;
    cursor: pointer;
    top: 40%;
    right: 0px;
    width: 30px;
    height: 50px;
    border: solid 2px #777;
    border-radius: 5px;
    color: #777;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .next-arrow-human {
    position: absolute;
    cursor: pointer;
    top: 40%;
    right: -25px;
    width: 30px;
    height: 50px;
    border: solid 2px #777;
    border-radius: 5px;
    color: #777;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .star-tag {
    position: absolute;
    left: -10px;
    bottom: 20px;
  }
  .bln-box {
    width: 100px;
    left: -10px;
    top: -82px;
    font-size: 12.5px;
  }
  .bln-box::before {
    left: 40%;
  }
  .bg-filter-box {
    height: 70px;
    width: 70px;
  }
  .bot-box {
    width: 100%;
  }
  .name {
    height: 40px;
    width: 70px;
    font-size: 10px;
  }
  .tag-ribbon-human {
    position: absolute;
    width: 100%;
    height: 15px;
    transform: rotateZ(0deg);
    font-size: 9px;
    line-height: 1;
    top: unset;
    bottom: 0px;
    left: 0px;
    text-align: center;
    padding: 2px;
    padding-left: 0px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .tag-ribbon-bot {
    position: absolute;
    width: 100%;
    height: 15px;
    transform: rotateZ(0deg);
    top: unset;
    bottom: 0px;
    left: 0px;
    font-size: 9px;
    line-height: 1;
    text-align: center;
    padding: 2px;
    padding-left: 0px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .tag-num {
    position: absolute;
    right: -5px;
    top: -5px;
    background: #ff3355;
    color: white;
    width:  25px;
    height: 25px;
    border-radius: 50%;
    z-index: 100;
  }
}
// アニメーション
@for $i from 0 through 100 {
  $enter-delay: 300ms;
  .list-icon {
    opacity: 0;
    animation: slide-icon .35s;
    animation-fill-mode:forwards;
    &.list-icon-#{$i} {
      animation-delay: #{$enter-delay + 50ms * $i};
    }
  }
}
@keyframes slide {
  0% {
    opacity: 0;
    transform: scale(0) translateX(-900px);
  }
  40% {
    opacity: 1;
    transform: scale(1) translateX(-600px);
  }
  50% {
    opacity: 1;
    transform: scale(1) translateX(-300px);
  }
  60% {
    opacity: 1;
    transform: scale(1) translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateX(0px);
  }
}
@keyframes slide-icon {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  60% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.workday-tooltip{
  position : relative;
  cursor   : pointer;
  display  : inline-block;
}
.tooltip-workday-message {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 12px;
  border-radius : 5px;
  width         : 200px;
  z-index       : 10;
  text-align: center;
}
.tooltip-workday-message:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 10px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.workday-tooltip:hover .tooltip-workday-message{
  display : inline-block;
  top     : 34px;
  left    : -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/SelectConvVender.vue